var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"min-h-screen"},[_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.masters.stats),function(stat,index){return _c('div',{key:index,staticClass:"w-full md:w-1/3 p-5"},[_c('StatsCard',{attrs:{"value":stat.value,"text":stat.text}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }